export default "__VITE_ASSET__YunZ3eZ4__"